import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { refreshUser } = useApp();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login");
            return;
        }
        const session_id = decodeURIComponent(match[1]);
        api.post("/auth/google/session", { session_id }, { withCredentials: true })
            .then(async () => {
                await refreshUser(true);
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/account");
            })
            .catch(() => navigate("/login"));
    }, [navigate, refreshUser]);

    return (
        <div className="min-h-[60vh] flex items-center justify-center text-[color:var(--ms-muted)] text-sm" data-testid="auth-callback">
            Accesso in corso…
        </div>
    );
}
